import styled from 'styled-components';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';

export const GridWrapper = styled(Box).attrs({ as: 'ul' })<{ isFullWidth?: boolean }>(
  ({ isFullWidth }) => ({
    display: 'grid',
    padding: 0,
    listStyle: 'none',
    gridTemplateColumns: '1fr',
    gap: 16,

    '@media not print': {
      [`@media (min-width: 1000px)`]: {
        gridTemplateColumns: `repeat(${isFullWidth ? '1' : '2'}, 1fr)`,
      },
    },

    '@media print': {
      gridTemplateColumns: `repeat(2, 1fr)`,
    },
  }),
);
